/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import React from 'react';
import { Helmet } from 'react-helmet';
import { captureUtmParamsFromLocation } from './src/utils/utm-storage';

export const onClientEntry = () => {
  if (typeof IntersectionObserver === `undefined`) {
    import(`intersection-observer`);
  }
  // Capture UTM params from the initial landing URL before Gatsby's client
  // router strips the query string on subsequent navigations.
  captureUtmParamsFromLocation();
};

// Also capture on every route change: covers deep links opened later in the
// same tab and any UTM-bearing internal links.
export const onRouteUpdate = () => {
  captureUtmParamsFromLocation();
};

// Client-side counterpart to gatsby-ssr.js. Keeps the robots tag in sync after
// SPA navigations between excluded and non-excluded pages.
export const wrapPageElement = ({ element, props }) => {
  if (!props?.pageContext?.excludeFromSitemap) return element;
  return (
    <>
      {element}
      <Helmet>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
    </>
  );
};
